import { WorkerMonthlyAttendance } from '@/entity/WorkerMonthlyAttendance';
import { getInitialState } from '@/vuex-store/worker-monthly-attendance/state';
export const mutationType = {
    // 필터옵션(조회기간, 조회 근무시간, 라이더 상태) 수정
    SET_FILTER_OPTION: 'SET_FILTER_OPTION',
    // 페이지 사이즈 수정 - 필터옵션과는 분리
    SET_PAGE_SIZE: 'SET_PAGE_SIZE',
    // 페이지 넘버 수정 - 필터옵션과는 분리 (필터옵션 deep 변경시 넘버 초기화를 위함)
    SET_PAGE_NUMBER: 'SET_PAGE_NUMBER',
    // 라이더 출근표 조회
    GET_WORKER_MONTHLY_ATTENDANCE_LIST: 'GET_WORKER_MONTHLY_ATTENDANCE_LIST',
    // 라이더 출근표 초기화
    RESET_WORKER_MONTHLY_ATTENDANCE_LIST: 'RESET_WORKER_MONTHLY_ATTENDANCE_LIST',
    // 전체 초기화
    RESET_STORE: 'RESET_STORE',
};
const mutations = {
    [mutationType.SET_FILTER_OPTION](state, payload) {
        Object.entries(payload).forEach(([key, value,]) => {
            // @ts-ignore
            state.filterOption[key] = value;
        });
    },
    [mutationType.SET_PAGE_SIZE](state, pageSize) {
        state.pageSize = pageSize;
    },
    [mutationType.SET_PAGE_NUMBER](state, pageNumber) {
        state.pageNumber = pageNumber;
    },
    [mutationType.GET_WORKER_MONTHLY_ATTENDANCE_LIST](state, data) {
        state.workerMonthlyAttendanceList = data.list.map((value) => new WorkerMonthlyAttendance(value));
        state.paginationData = data.paginationData;
    },
    [mutationType.RESET_WORKER_MONTHLY_ATTENDANCE_LIST](state) {
        state.workerMonthlyAttendanceList = [];
    },
    [mutationType.RESET_STORE](state) {
        Object.assign(state, getInitialState());
    },
};
export default mutations;
